<template>
  <CustomModal v-if="open && deal" @close="$emit('close')" class="invest-modal">
    <template v-slot:body>
      <LeftGradientBlockLayout>
        <LeftGradientBlockLayoutHead>
          <template slot="title">{{ $t('modalTitle') }}</template>
          <template slot="form-menu">
            <RadioTags v-model="deal_type"
                       :options="deal_type_list"
                       name="deal-type"
                       :disabled="true"/>
          </template>
        </LeftGradientBlockLayoutHead>
        <ManualDealsEditForm :deal_type="deal_type" :deal="deal" @success="$emit('close')"/>
      </LeftGradientBlockLayout>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import LeftGradientBlockLayout from "@/components/layouts/cabinet/LeftGradientBlockLayout/LeftGradientBlockLayout";
import LeftGradientBlockLayoutHead
  from "@/components/layouts/cabinet/LeftGradientBlockLayout/LeftGradientBlockLayoutHead";
import ManualDealsEditForm from "@/components/cabinet/Investments/modals/ManualDealsModal/ManualDealsEditForm";
import RadioTags from "@/components/UI/RadioTags";
import {dealTypes} from "@/utilities/invest_deal_types";

export default {
  name: "ManualIncomesEditModal",
  components: {
    RadioTags,
    ManualDealsEditForm,
    LeftGradientBlockLayoutHead,
    LeftGradientBlockLayout,
    CustomModal
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    deal: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      deal_type: null,
    }
  },
  computed: {
    deal_type_list() {
      return [
        {value: dealTypes.TYPE_INCOME_DIVIDEND, text: this.$t('dividend'), color: 'green'},
        {value: dealTypes.TYPE_INCOME_COUPON, text: this.$t('coupon'), color: 'green'},
        {value: dealTypes.TYPE_INCOME_AMORTIZATION, text: this.$t('amortization'), color: 'green'}
      ]
    }
  },
  watch: {
    open(val) {
      if (val && this.deal) {
        this.deal_type = this.deal.type;
      }
    },
    deal: {
      immediate: true,
      handler(val) {
        if (val) {
          this.deal_type = val.type;
        }
      }
    }
  },
  i18n: {
    messages: {
      en: {
        modalTitle: 'Edit income',
        dividend: 'Dividend',
        coupon: 'Coupon',
        amortization: 'Amortization',
      },
      ru: {
        modalTitle: 'Редактировать доход',
        dividend: 'Дивиденд',
        coupon: 'Купон',
        amortization: 'Амортизация',
      }
    }
  }
}
</script>

